import apiClient from '@/api/client';
export { options } from '@/api/client';

const modules = {};
const requireModule = require.context('@/api/resources/', true, /.*\.js$/);
requireModule.keys().forEach((fileName) => {
    const moduleName = fileName.replace(/(\.\/|\.js)/g, '');

    modules[moduleName] = requireModule(fileName).default;
});

class Api {
    constructor () {
        this.client = apiClient;
    }

    errorLog (error) {
        return this.client.request ({
            method: 'POST',
            path: '/public/v1/error-logs',
            data: { body: error },
        });
    }

    login (credentials) {
        return this.client.request ({
            method: 'POST',
            path: '/oauth/token',
            data: { client_id: process.env.VUE_APP_CLIENT_ID, ...credentials },
        });
    }

    ottLogin (ott) {
        return this.client.request ({
            method: 'POST',
            path: '/oauth/ott-token',
            data: { ott },
        });
    }

    googleRedirect () {
        return this.client.request({
            method: 'POST',
            path: '/oauth/google/redirect',
            data: { client_id: process.env.VUE_APP_CLIENT_ID },
        });
    }

    googleCallback (data) {
        return this.client.request({
            method: 'POST',
            path: '/oauth/google/callback',
            data,
        });
    }

    logout () {
        return this.client.request ({
            method: 'DELETE',
            path: '/oauth/token',
        });
    }

    register (data) {
        return this.client.request ({
            method: 'POST',
            path: '/publisher/v1/register',
            data: data,
        });
    }

    resetPassword (data) {
        return this.client.request ({
            method: 'POST',
            path: '/password/publisher/email',
            data: data,
        });
    }

    setNewPassword (data) {
        return this.client.request({
            method: 'POST',
            path: '/password/publisher/reset',
            data: data,
        });
    }

    getDicts () {
        return this.client.request ({
            method: 'GET',
            path: '/storage/dict.json',
            errorMessages: { 404: 'Could not load dictionaries' },
        }, { simple: true });
    }

    getDictCategories () {
        return this.client.request ({
            method: 'GET',
            path: '/public/v1/dict/categories',
            errorMessages: { 404: 'Could not load dictionaries' },
            params: { limit: -1 },
        });
    }

    getDictCountries () {
        return this.client.request ({
            method: 'GET',
            path: '/public/v1/dict/countries',
            errorMessages: { 404: 'Could not load dictionaries' },
            params: { limit: -1 },
        });
    }

    getApiAccessToken () {
        return this.client.request ({
            method: 'POST',
            path: '/oauth/pat',
        });
    }

    revokeApiAccessToken () {
        return this.client.request ({
            method: 'DELETE',
            path: '/oauth/pat',
        });
    }
}

Object.entries(modules).forEach((entry) => {
    const [name, value] = entry;
    Api.prototype[name] = value;
});

export default new Api;
